import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Page Not Found - Extranet';
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 dark:bg-dark-900 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/20">
          <svg
            className="h-12 w-12 text-primary-600 dark:text-primary-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 9a4 4 0 115.656 5.656M9 15h.01M15 9h.01M12 12h.01"
            />
          </svg>
        </div>

        <div className="space-y-3">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Page Not Found</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            The page you are looking for does not exist.
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">Check the URL and try again.</p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button variant="primary" onClick={() => navigate('/')}>
            Go to Dashboard
          </Button>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>

        <div className="pt-6">
          <p className="text-xs text-gray-500 dark:text-gray-400">Error Code: 404 - Not Found</p>
        </div>
      </div>
    </div>
  );
}
